<template>
  <div id="client-report-wrapper">
    <!-- Chart section (centered like in clientReportsBarChart.vue) -->
    <div class="d-flex justify-content-center">
      <div class="card" id="card-chart" v-if="isLineChartReady">
        <div class="card-body">
          <h5 class="card-title text-center">Contract Profitability Line Chart</h5>
          <Line :data="lineChartData" :options="chartOptions" />
        </div>
      </div>
      <div class="card" id="card-chart" v-else>
        <div class="card-body">
          <h3 class="card-title">No Data to display</h3>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, ref, onMounted } from "vue";
import { Line } from "vue-chartjs";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
} from "chart.js";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
);

const props = defineProps({
  lineChartData: {
    type: Object,
    required: true,
  },
});

const chartOptions = {
  responsive: true,
  maintainAspectRatio: true,
  dataLabels: {
    display: false,
  },
  scales: {
    x: {
      display: true,
      title: {
        display: true,
        text: "Report Date",
      },
      grid: {
        display: false,
        drawBorder: false,
      },
      ticks: {
        fontSize: 0,
        padding: 0,
      },
    },
    y: {
      display: true,
      title: {
        display: true,
        text: "EUR",
      },
      grid: {
        drawTicks: false,
        drawBorder: true,
        display: true,
        offsetGridLines: true,
      },
      ticks: {
        fontSize: 0,
        padding: 0,
      },
    },
  },
  plugins: {
    datalabels: {
      color: "white",
      font: {
        size: 0,
      },
    },
    legend: {
      display: true,
      position: "top",
    },
    tooltip: {
      enabled: true,
      intersect: false,
      displayColors: true,
      callbacks: {
        label: function (context) {
          return context.dataset.label + ": " + context.parsed.y + " EUR";
        },
      },
    },
  },
  elements: {
    point: {
      radius: 4,
      text: 10,
    },
    line: {
      tension: 0.4,
      fill: true,
      borderWidth: 2,
    },
  },
};

const isLineChartReady = ref(false);

onMounted(() => {
  if (props.lineChartData && Object.keys(props.lineChartData).length !== 0) {
    isLineChartReady.value = true;
  }
});
</script>

<style lang="scss">
#client-report-wrapper {
  padding-bottom: 40px;
}

#card-chart {
  width: 100%;
  max-width: 85%; // Limit maximum width
  margin: 20px 0;
}

.card-body {
  padding: 1.5rem;
}
</style>
